module.exports = __webpack_public_path__ + "models/1baa45f5da23dceb37e1e9c2b04b2969.glb";